import { render, staticRenderFns } from "./AZSorter.vue?vue&type=template&id=b02986d6"
import script from "./AZSorter.vue?vue&type=script&lang=js"
export * from "./AZSorter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports